import { PeopleFilterFields } from 'src/app/people/models/peopleFilterFields';
import { FilterOperatorType } from '../components/odata-filter/models/filter-operator-type';
import {
  FilterGroup,
  ODataFilter,
  ODataSubFilter
} from '../components/odata-filter/models/odata-filter';
import { ODataFilterBuilder } from './odata-filter-builder';

const isSearchValueAGuid =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export class SearchBoxFilterModel implements ODataFilter {
  childFieldName = '';
  targetFieldId = '';
  filterGroup = FilterGroup.SystemFields;
  values = [];
  valueType = null;
  displayName = '';
  targetField = '';
  subFilter = new ODataSubFilter();

  constructor(
    public targetFields: { name: string; isGuid: boolean; isEmail: boolean }[],
    public unaccent: boolean = false
  ) {}
  buildFilter(searchValue: string): { or: any } {
    if (
      this.targetFields.findIndex((x) => x.isGuid) != -1 &&
      isSearchValueAGuid.test(searchValue)
    ) {
      //they're searching by a guid and one of the target fields is a guid
      return {
        or: this.targetFields
          .filter((x) => x.isGuid)
          .map((targetField) =>
            ODataFilterBuilder.buildGuidFilter(targetField.name, searchValue, FilterOperatorType.eq)
          )
      };
    }
    if (
      this.targetFields.findIndex((x) => x.isEmail) != -1 &&
      searchValue.includes('@') &&
      searchValue.includes(';')
    ) {
      //is there an email target fields and did the search include an @ and a ; which we will use to delimit multiple email addresses
      return {
        or: this.targetFields
          .filter((x) => x.isEmail)
          .map((targetField) =>
            ODataFilterBuilder.buildEmailFilter(
              targetField.name,
              searchValue,
              FilterOperatorType.in
            )
          )
      };
    }
    if (this.targetFields.findIndex((x) => x.name == PeopleFilterFields.textSearch) !== -1) {
      //no need to search anything else if there's a textSearch field
      return {
        or: [
          ODataFilterBuilder.buildStringFilter(
            PeopleFilterFields.textSearch,
            searchValue,
            FilterOperatorType.contains,
            false,
            false
          )
        ]
      };
    }

    return {
      or: this.targetFields
        .filter((x) => !x.isGuid)
        .map((targetField) =>
          ODataFilterBuilder.buildStringFilter(
            targetField.name,
            searchValue,
            FilterOperatorType.contains,
            false,
            this.unaccent
          )
        )
    };
  }
}
